<template>
  <div class="green-bg login-home">
    <LocaleSwitcher />
    <div class="d-md-flex justify-space-between login-page">
      <v-container class="login-content">
        <Logo green="green" />
        <LoginForm />
      </v-container>
      <div class="login-bg">
        <object
          style="height: 100%"
          type="image/svg+xml"
          :data="loginImageUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  components: {
    LoginForm: () => import("../components/Login/LoginForm"),
    Logo: () => import("../components/core/Logo"),
    LocaleSwitcher: () => import("../components/core/LocaleSwitcher"),
  },
  computed: {
    loginImageUrl() {
      return require('~/whitelabel.config')[process.env.VUE_APP_BRAND].loginImageUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: $green;
}
</style>
